import React from "react";
import Image from "next/image";
import Link from "next/link";
import Button from "@/Components/Button";

const Custom500: React.FC = () => {
  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[150px] pb-[56px] lg:pb-[80px] xl:pb-[100px] relative z-0">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>

          <div className="container">
            <div className="blog-heading mb-[32px]">
              <Image
                src="/images/500.svg"
                alt="500 illustration"
                width={640}
                height={344}
                className="mx-auto mb-[32px]"
              />
              <h1 className="text-center text-white font-[800] text-display capitalize mb-[12px]">
                Oops...! Something Went Wrong
              </h1>
              <p className="max-w-[1000px] mx-auto text-gray-50 text-center font-regular text-subtitle-3">
                {
                  "Oops, something's not quite right. Our website is experiencing some technical difficulties, but our team is on it. We appreciate your patience and hope to have things up and running again soon."
                }
              </p>
              <div className="flex justify-center lg:mt-[40px] mt-[20px]">
                <Link href="/">
                  <Button label="Back to Home" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Custom500;
